import CGVConsult from '@/views/CGVConsult.vue';
import CGVPreConsultForm from '@/views/CGVPreConsultForm.vue';
import CGVData from '@/views/CGVData.vue';
import CGVProposals from '@/views/CGVProposals.vue';
import ProposalDetails from '@/views/ProposalDetails.vue';

const name = 'cgv';
const path = '/cgv';

export default [
  // routes
  {
    name: `${name}-consult`,
    path: `${path}/consultar`,
    component: CGVConsult,
  },
  {
    name: `${name}-pre-consult-form`,
    path: `${path}/simulacao`,
    component: CGVPreConsultForm,
  },
  {
    name: `${name}-formalization`,
    path: `${path}/formalizacao`,
    component: CGVData,
  },
  {
    name: `${name}-proposals`,
    path: `${path}/propostas`,
    component: CGVProposals,
  },
  {
    name: `${name}-proposal-details`,
    path: `${path}/detalhes-proposta/:proposal_id`,
    component: ProposalDetails,
  },
  {
    name: `${name}-update-proposal`,
    path: `${path}/atualizar-proposta/:proposal_id`,
    component: () => import('@/views/cgv/UpdateProposal.vue'),
  },
];
